import { Component, OnInit } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { AuthService } from "src/app/_app-core/services/auth/auth.service";
@Component({
    selector: "app-vendor-profile",
    templateUrl: "./vendor-profile.component.html",
    styleUrls: ["./vendor-profile.component.scss"],
})
export class VendorProfileComponent implements OnInit {
    masterData: any;
    responseData: any;
    isError = false;
    vendorData: any;
    displayName: any;
    loading = true;
    isCondensed: boolean = false;
    currentLayout = {
        isCondensed: true,
    };
    freqExist = false;
    statusExist = false;

    constructor(private http: HttpClient, private authService: AuthService) {}

    toggleSidebar() {
        this.currentLayout.isCondensed = !this.currentLayout.isCondensed;
        document.body.setAttribute(
            "data-sidebar-size",
            this.currentLayout.isCondensed ? "condensed" : "default"
        );
    }

    ngOnInit(): void {
        this.displayName = localStorage.getItem("displayName");
        const userData = {
            sellerCode: localStorage.getItem("vendorCode"),
            session: { sessionId: localStorage.getItem("eippSession") },
        };

        this.authService.fetchVendorMasterData(userData).subscribe(
            (res) => {
                this.loading = false;
                this.responseData = res;
                if (this.responseData.success) {
                    this.vendorData = this.responseData.data.supplier;
                    console.log(this.vendorData);

                    if (
                        typeof this.vendorData.taxReturnStatus !==
                            "undefined" &&
                        this.vendorData.taxReturnStatus !== ""
                    ) {
                        this.statusExist = true;
                    }

                    if (
                        typeof this.vendorData.taxReturnFrequency !==
                            "undefined" &&
                        this.vendorData.taxReturnFrequency !== ""
                    ) {
                        this.freqExist = true;
                    }
                } else {
                    this.isError = true;
                    console.log("Error Here");
                }
            },
            (error) => {
                this.loading = false;
                this.isError = true;
                console.log(error);
            }
        );
    }
}
